<div class="date-stepper d-flex flex-row align-items-center">
  <div class="mr-1">
    <button
      type="button"
      class="btn btn-success user-select-none"
      (click)="goToToday()"
    >
      Today
    </button>
  </div>

  <div class="mr-1">
    <button
      type="button"
      class="btn btn-light user-select-none arrow-btn"
      (click)="stepDate(-1)"
      [disabled]="isPrevDayDisabled()"
      aria-label="Previous day"
    >
      <tr-icon [icon]="icon.arrowLeft" [size]="iconSize.small"></tr-icon>
    </button>
  </div>

  <div class="input-group datepicker-box background-background">
    <button
      type="button"
      class="btn btn-info btn-light no-round-right border-border user-select-none"
      (click)="datepicker.toggle()"
    >
      <tr-icon [icon]="icon.date" [size]="iconSize.medium"></tr-icon>
    </button>
    <input
      class="form-control date-input user-select-none border-border"
      type="text"
      placeholder="Select date"
      autocomplete="off"
      readonly
      ngbDatepicker
      container="body"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [weekdays]="true"
      [firstDayOfWeek]="7"
      #datepicker="ngbDatepicker"
      name="date"
      [ngModel]="date"
      (ngModelChange)="onModelChange($event)"
      (click)="datepicker.toggle()"
    />
  </div>

  <div class="ml-1">
    <button
      type="button"
      class="btn btn-light user-select-none arrow-btn"
      (click)="stepDate(1)"
      [disabled]="isNextDayDisabled()"
      aria-label="Next day"
    >
      <tr-icon [icon]="icon.arrowRight" [size]="iconSize.small"></tr-icon>
    </button>
  </div>
</div>
